import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { MANAGEMENT_CARD_BORDER_RADIUS, StyledManagementCardWrapper } from "../cards-components/styles";

export const StyledMCPConnectionBanner = styled(StyledManagementCardWrapper)`
    padding: 8px;
    flex-direction: row;
    gap: 36px;
    justify-content: flex-start;
    background-color: ${colorsPalettes.carbon["0"]};
`;

export const StyledMCPBannerImgWrapper = styled(Flex)`
    align-items: center;
    justify-content: center;
    width: 340px;
    height: 203px;
    overflow: hidden;
    border-radius: ${MANAGEMENT_CARD_BORDER_RADIUS}px;
    background: ${colorsPalettes.sky["100"]};
`;

export const StyledMCPBannerCopyURLWrapper = styled(Flex)`
    align-items: center;
    gap: 8px;
    overflow: hidden;
    padding: 4px 4px 4px 16px;
    border-radius: 25px;
    border: 1px solid ${colorsPalettes.carbon["100"]};
`;
